Link = require('react-router').Link
RouteHandler = require('react-router').RouteHandler

# Provides global navigation for app e.g. the "Hello | Styleguide" at the top.
module.exports = React.createClass
  displayName: 'HelloWorld'
  render: ->
    React.createElement("div", null,
      React.createElement("header", null, React.createElement(Link, {"to": "hello"}, "Hello"), " | ", React.createElement(Link, {"to": "styleguide"}, "Styleguide")),
      React.createElement(RouteHandler, null)
    )



/** WEBPACK FOOTER **
 ** ../cjsx-loader!./src/scripts/app.cjsx
 **/